import { Platform } from '@/utils/platform';
import { invoke } from '../../QTBridge';

export const SAVE_IMAGE_OPERATE_TYPE = {
  WHOLE: 1, // 图片
  CLIP: 2, // 快照
};

export const uploadSnapshot = (data: {
  base64Image: string;
  ImageType: string;
  operateType: number;
}) => {
  if (Platform.isPOPO) {
    console.log(
      `call qt: SnapshotUpload. ImageType=${data.ImageType} operateType=${data.operateType}`
    );
    invoke(`SnapshotUpload`, data).catch((e) => console.error(e));
  }
};
